/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiSettingFromJSON, StreemApiSettingToJSON, } from './';
export function StreemApiListCompanyPublicSettingsResponseFromJSON(json) {
    return StreemApiListCompanyPublicSettingsResponseFromJSONTyped(json, false);
}
export function StreemApiListCompanyPublicSettingsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'settings': !exists(json, 'settings') ? undefined : (json['settings'].map(StreemApiSettingFromJSON)),
    };
}
export function StreemApiListCompanyPublicSettingsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'settings': value.settings === undefined ? undefined : (value.settings.map(StreemApiSettingToJSON)),
    };
}
//# sourceMappingURL=StreemApiListCompanyPublicSettingsResponse.js.map